<div *ngIf="displayError">
    <p class="formFieldErrorMessage">{{errorMessage}}</p>
</div>
